import api from './api';
const BASE = '/tikane';

export default {
  list:    params => api.get(BASE,    { params: { functionCode:'TIKANE_VIEW', ...params } }).then(r=>r.data),
  get:     id     => api.get(`${BASE}/${id}`, { params: { functionCode:'TIKANE_VIEW' } }).then(r=>r.data),
  create:  data   => api.post(BASE,   { ...data, functionCode:'TIKANE_CREATE' }).then(r=>r.data),
  update:  (id,d) => api.put(`${BASE}/${id}`, { ...d, functionCode:'TIKANE_UPDATE' }).then(r=>r.data),
  remove:  id     => api.delete(`${BASE}/${id}`, { data: { functionCode:'TIKANE_DELETE' } }).then(r=>r.data),
};
